import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["popup", "button", "yearSelect", "monthSelect"];

  toggleMonthPicker(event) {
    event && event.preventDefault();
    this.popupTarget.classList.toggle("open");
  }

  goToNewDate(event) {
    event && event.preventDefault();
    this.dispatchChangeEvent();
    this.newLocation = this.url;
  }

  shiftBack(event) {
    event && event.preventDefault();
    this.dispatchChangeEvent();
    this.newLocation = this.prevURL;
  }

  shiftForward(event) {
    event && event.preventDefault();
    this.dispatchChangeEvent();
    this.newLocation = this.nextURL;
  }

  goToThisMonth(event) {
    event && event.preventDefault();
    this.dispatchChangeEvent();
    this.newLocation = this.todayURL;
  }

  dispatchChangeEvent() {
    this.popupTarget.classList.remove("open");
    this.buttonTarget.innerText = moment(this.selectedDate).format("MMMM YYYY");
    document.dispatchEvent(createCustomEvent("month-picker:date-change", this.element, { newDate: this.selectedDate }));
  }

  //
  // GETTERS AND SETTERS
  //

  get date() {
    return (this.data.has('date') ? moment(this.data.get('date')) : moment()).format('YYYY-MM-DD');
  }

  get selectedDate() {
    return `${this.yearSelectTarget.value}-${this.monthSelectTarget.value}-01`;
  }

  set newLocation(url) {
    if (this.redirectOnChange) {
      document.location = url;
    }
  }

  get prevDate() {
    return moment(this.date).subtract('1', 'month').format('YYYY-MM-DD');
  }

  get nextDate() {
    return moment(this.date).add('1', 'month').format('YYYY-MM-DD');
  }

  get baseURL() {
    return this.data.get('base-url') || window.location.href;
  }

  get url() {
    return this.baseURL.replace(/DATE/g, this.selectedDate);
  }

  get prevURL() {
    return this.baseURL.replace(/DATE/g, this.prevDate);
  }

  get nextURL() {
    return this.baseURL.replace(/DATE/g, this.nextDate);
  }

  get todayURL() {
    return this.baseURL.replace(/DATE/g, moment().format('YYYY-MM-DD'));
  }

  get redirectOnChange() {
    return !!this.data.get("redirect-on-change");
  }
};



// WEBPACK FOOTER //
// ./app/components/date_selects/assets/javascript/date-selects-month-picker-controller.js